/**
 * Domain-based branding configuration.
 * Returns app name, logo, tagline based on the current hostname.
 */

import {
  admin_login_bg,
  Proschool_LOGO_1,
  saddle_river_day_school_logo,
  srds_admin,
  srds_ai_logo,
  proschool_ai_logo,
} from "../assets/images/images";
const srds_school_logo = saddle_river_day_school_logo;

const BRANDING = {
  "srds.ai": {
    variant: "srds",
    appName: "SRDS",
    chatbotname: "SRDS.ai",
    productName: "SRDS.ai",
    fullName: "Saddle River Day School",
    tagline: "AI-powered educational platform",
    logo: srds_school_logo,
    adminLogo: srds_admin,
    favicon: "/favicon_srds.ico",
    primaryColor: "#1976d2",
    contactEmail: "kmerges@saddleriverday.org",
    supportEmail: "kmerges@saddleriverday.org",
    infoEmail: "info@saddleriverday.org",
    helpEmail: "help@saddleriverday.org",
    phone: "+1 201-327-4050",
    phoneTel: "+12013274050",
    address:
      "Saddle River Day School, 147 Chestnut Ridge Road, Saddle River, NJ 07458",
    addressUrl:
      "https://www.google.com/maps/place/Saddle+River+Day+School/@41.0307394,-74.0880125,17z/data=!3m1!4b1!4m6!3m5!1s0x89c2e436c9e7ef3b:0xf060c34a65b01898!8m2!3d41.0307394!4d-74.0854376!16zL20vMGRkYzZ5?entry=ttu",
    social: {
      facebook: "https://www.facebook.com/saddleriverdayschool",
      twitter: "https://twitter.com/srDSrebels",
      instagram: "https://www.instagram.com/saddleriverday/",
      vimeo: "https://vimeo.com/srds",
      linkedin: "",
    },
    bookDemoUrl: "",
    filename: "SRDS.ai Files",
    chatbotlogo: srds_ai_logo,
    AIAssiastantSenderName: "SRDS.AI",
  },
  "proschool.ai": {
    variant: "proschool",
    appName: "ProSchool",
    chatbotname: "ProSchool.ai",

    productName: "ProSchool.ai",
    fullName: "ProSchool",
    tagline: "AI-powered educational platform",
    logo: Proschool_LOGO_1,
    adminLogo: admin_login_bg,
    favicon: "/favicon.ico",
    primaryColor: "#0068FF",
    contactEmail: "support@proschool.ai",
    supportEmail: "support@proschool.ai",
    infoEmail: "support@proschool.ai",
    helpEmail: "help@proschool.ai",
    // phone: '+971-581140055',
    // phoneTel: '+971581140055',
    address: "ProSchool, 18 West 18th Street New York, NY 10011",
    addressUrl: "https://maps.app.goo.gl/wCkdvCYmJUidHP5X7",
    social: {
      facebook: "https://www.facebook.com/proschool.ai1",
      twitter: "https://x.com/Proschoolai",
      instagram: "https://www.instagram.com/proschool.ai",
      vimeo: "",
      linkedin: "https://www.linkedin.com/company/proschool-ai",
      youtube: "https://www.youtube.com/@ProSchoolAI",
    },
    bookDemoUrl: "https://calendly.com/d/crkg-4rz-8yh/proschool-ai",
    filename: "My Files",
    chatbotlogo: proschool_ai_logo,
    AIAssiastantSenderName: "PROSCHOOL.AI",
  },
};

const DEFAULT_BRANDING = BRANDING["proschool.ai"];

/**
 * Get branding config for the current domain.
 *
 * Local dev override: Set REACT_APP_FORCE_BRAND=srds or proschool in .env
 * to force a specific brand on localhost.
 */
export const getBranding = (hostname) => {
  // Dev override via env var (e.g., REACT_APP_FORCE_BRAND=srds)
  const forceBrand = process.env.REACT_APP_FORCE_BRAND;
  if (forceBrand) {
    if (forceBrand === "srds") return BRANDING["srds.ai"];
    if (forceBrand === "proschool") return BRANDING["proschool.ai"];
  }

  const host = hostname || window.location.hostname;

  for (const [domain, branding] of Object.entries(BRANDING)) {
    if (host === domain || host.endsWith(`.${domain}`)) {
      return branding;
    }
  }

  // localhost or unknown -> use ProSchool branding as default
  return DEFAULT_BRANDING;
};

export default getBranding;
